import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=755e77e4&scoped=true"
import script from "./uploadBtn.vue?vue&type=script&lang=js"
export * from "./uploadBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadBtn.vue?vue&type=style&index=0&id=755e77e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e77e4",
  null
  
)

export default component.exports